import { Box, Step, StepLabel, Stepper, styled, Tab, Tabs } from '@mui/material';
import React, { useMemo } from 'react';

import { ITemplateModalStep } from '../../../../../types/templates';

interface IProps {
  isEditMode: boolean;
  activeStep: number;
  steps: ITemplateModalStep[];
  handleStepClick: (step: ITemplateModalStep) => void;
}

const StyledContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(3),
  paddingRight: 0,
  width: 208,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'row',
  alignSelf: 'flex-start',
}));

const StyledStepper = styled(Stepper)({
  cursor: 'pointer',
  '& .MuiStepConnector-line': { minHeight: 17.5 },
  '& .MuiStepConnector-root': { maxHeight: 17.5 },
  '& .MuiStepLabel-iconContainer': { pr: 0 },
});

const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'isEditMode',
})<{ isEditMode: boolean }>(({ isEditMode, theme }) => ({
  alignItems: 'flex-start',
  py: theme.spacing(1.125),
  pl: isEditMode ? 0 : theme.spacing(2),
  marginBottom: theme.spacing(1.875),
  height: 42,
  minHeight: 42,
  '&:last-child': { marginBottom: 0 },
}));

export const NavigationMenu: React.FC<IProps> = ({ isEditMode, activeStep, steps, handleStepClick }) => {
  const activeStepValue = useMemo(() => steps.find((step) => step.id === activeStep)?.value, [steps, activeStep]);

  return (
    <StyledContainer>
      {!isEditMode && (
        <StyledStepper activeStep={activeStep - 1} orientation="vertical">
          {steps.map((step) => (
            <Step key={step.id} onClick={() => handleStepClick(step)} data-action={`step_${step.id}_btn`}>
              <StepLabel />
            </Step>
          ))}
        </StyledStepper>
      )}
      <Tabs orientation="vertical" value={activeStepValue} sx={{ flex: 1 }}>
        {steps.map((step) => {
          const { id, label, value } = step;
          return (
            <StyledTab
              isEditMode={isEditMode}
              key={id}
              label={label}
              value={value}
              onClick={() => handleStepClick(step)}
              disableRipple
              data-action={`tab_${id}_btn`}
            />
          );
        })}
      </Tabs>
    </StyledContainer>
  );
};
